module.exports = __webpack_public_path__ + "media/leaderboard/assets/bob_mcmurray-73f9678704ee320252124afe28cda521.png";